<template>
  <LayoutBasic :showLinksMenu="false" :routeBack="{ name: 'adminDashboard' }">

    <template v-slot:navigation-title>
      Clases de soporte
    </template>

    <template v-slot:navigation-content>
      <v-list dense nav class="pt-0">
        <v-subheader>General</v-subheader>

        <v-list-item @click="checkLocalidades()">
          <v-list-item-icon><v-icon>mdi-map-search</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Check Localidades</v-list-item-title></v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push({ name: 'condicionesIva' })">
          <v-list-item-icon><v-icon>mdi-file-certificate</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Condiciones IVA</v-list-item-title></v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push({ name: 'estados' })">
          <v-list-item-icon><v-icon>mdi-flag-outline</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Estados</v-list-item-title></v-list-item-content>
        </v-list-item>

        <v-divider class="my-2"></v-divider>

        <v-subheader>Comerciales</v-subheader>

        <v-list-item @click="$router.push({ name: 'formasDePago' })">
          <v-list-item-icon><v-icon>mdi-cash-multiple</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Formas de Pago</v-list-item-title></v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push({ name: 'plazoVencimiento' })">
          <v-list-item-icon><v-icon>mdi-calendar-clock</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Plazo de Vencimiento</v-list-item-title></v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push({ name: 'recargo' })">
          <v-list-item-icon><v-icon>mdi-percent</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Recargo</v-list-item-title></v-list-item-content>
        </v-list-item>

        <v-divider class="my-2"></v-divider>

        <v-subheader>Productos y logística</v-subheader>

        <v-list-item @click="$router.push({ name: 'unidadMedida' })">
          <v-list-item-icon><v-icon>mdi-ruler-square</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Unidad de Medida</v-list-item-title></v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push({ name: 'motivoCambio' })">
          <v-list-item-icon><v-icon>mdi-swap-horizontal</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Motivo de Cambio</v-list-item-title></v-list-item-content>
        </v-list-item>

        <v-divider class="my-2"></v-divider>

        <v-subheader>Notificaciones</v-subheader>

        <v-list-item @click="$router.push({ name: 'tipoNotificaciones' })">
          <v-list-item-icon><v-icon>mdi-bell-ring</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Tipo de Notificaciones</v-list-item-title></v-list-item-content>
        </v-list-item>
      </v-list>
    </template>

    <template v-slot:navigation-controller>
      <!-- Opcional: botones o filtros superiores -->
    </template>

    <template v-slot:vista-previa>
      <v-container fluid>
        <router-view />
      </v-container>
    </template>
  </LayoutBasic>
</template>

<script>
import LayoutBasic from "@/layouts/LayoutBasic.vue";

export default {
  name: "SoporteHome",
  components: {
    LayoutBasic,
  },
  methods: {
    checkLocalidades() {
      this.axios
        .get("/empresas/ubicaciones")
        .then((response) => {
          const data = response.data;
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "success",
            text: `${data}`,
            icon: "mdi-check",
            timeout: 3000,
          });
        })
        .catch((e) => {
          console.error(e);
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "info",
            text: `${e}`,
            icon: "mdi-information",
            timeout: 3000,
          });
        });
    },
  },
};
</script>

<style scoped>
.v-list {
  max-height: 90vh;
  overflow-y: auto;
}
</style>
